<template>
  <div class="page">
    <common-header></common-header>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <common-footer></common-footer>
  </div>
</template>

<script type="text/ecmascript-6">
import CommonHeader from './components/business/CommonHeader'
import CommonFooter from './components/business/CommonFooter'
export default {
  data() {
    return {

    }
  },
  components: {
    CommonHeader,
    CommonFooter
  }
}
</script>

<style scoped lang="scss">
@import "./common/common.scss";
.page{
  min-width: $min-width;
}
</style>



// WEBPACK FOOTER //
// src/apps/zcx/app.vue